import src from "IMAGE";
export default { src, width: 1447, height: 549, blurWidth: 0, blurHeight: 0};
